module.exports = __webpack_public_path__ + "img/12.a92284f7.jpg";